<template>
    <div class="closure-container">
        <ChartComponent :charts="charts" />
        <q-table :rows="data" :columns="closureDataColumns" :loading="loading" :rows-per-page-options="[20]" :filter="filter" :visibleColumns="closureVisibleColumns">
            <template v-slot:top-left>
                <div class="users-title view-user-title">
                    <q-input outlined dense debounce="300" v-model="filter" placeholder="Search Table">
                        <template v-slot:append>
                            <q-icon name="close" @click="filter = ''" class="cursor-pointer" />
                            <q-icon name="search" />
                        </template>
                    </q-input>

                    <q-select v-model="closureVisibleColumns" multiple outlined dense options-dense
                        :display-value="$q.lang.table.columns" emit-value map-options
                        :options="closureTableColumns" option-value="value"
                        style="min-width: 150px; margin-bottom: 0;" />
                </div>
            </template>
            <template v-slot:body-cell="props">
                <q-td :props="props">
                    <span v-if="props.value && props.col.name.includes('timestamp')">
                        {{ props.value.split('T')[0] }}
                    </span>
                    <span v-else-if="props.value && props.col.name.includes('date')">
                        {{ props.value.split('T')[0] }}
                    </span>
                    <span v-else>
                        {{ props.value }}
                    </span>
                </q-td>
            </template>
            <template v-slot:top-right>
                <q-btn :loading="refreshing" no-caps flat color="light-blue" icon="refresh" @click="refreshASAResponses()">
                    <q-tooltip class="text-body2" anchor="center left" self="center right" >
                        Click to refresh data with latest form responses.
                    </q-tooltip>
                </q-btn>
                <q-btn no-caps fab-mini flat icon="download" @click="exportTable(getVisibleRows(data, closureVisibleColumns), 'ASA Case Closure Data.csv', { columns: closureDataColumns })" />
            </template>
        </q-table>
    </div>
</template>

<script>

import api from "@/services/api/api"
import notify from '@/services/util/notify';
import ChartComponent from "./ChartComponent.vue";
import { exportTable, getVisibleRows } from "../../services/util/file";


export default {
    props: {
        data: {
            type: Array,
        },
        charts: {
            type: Array,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ChartComponent,
    },
    data() {
        return {
            exportTable: exportTable,
            getVisibleRows: getVisibleRows,
            filter: null,
            closureDataColumns: [
                { name: 'case_id_number', label: 'Case ID', align: 'left', field: row => row.case_id_number, sortable: true},
                { name: 'timestamp', label: 'Timestamp', align: 'left', field: row => row.timestamp, sortable: true},
                { name: 'date_case_allocated', label: 'Date Case Allocated', align: 'left', field: row => row.date_case_allocated, sortable: true},
                { name: 'date_case_closed', label: 'Date Case Closed', align: 'left', field: row => row.date_case_closed, sortable: true},
                { name: 'time_case_open', label: 'Time Open (days)', align: 'left', field: row => row.time_case_open, sortable: true},
                { name: 'barriers_to_attendance', label: 'Barriers to Attendance', align: 'left', field: row => row.barriers_to_attendance, },
                { name: 'case_type', label: 'Case Type', align: 'left', field: row => row.case_type, sortable: true},
                { name: 'kaimahi_first_name', label: 'Kaimahi First Name', align: 'left', field: row => row.kaimahi_first_name, sortable: true},
                { name: 'other_agencies_worked_with', label: 'Other Agencies Worked With', align: 'left', field: row => row.other_agencies_worked_with },
                { name: 'outcome', label: 'Outcome', align: 'left', field: row => row.outcome },
                { name: 'referrals_made_for_parent', label: 'Referrals Made for Parent', align: 'left', field: row => row.referrals_made_for_parent },
                { name: 'referrals_made_for_rangatahi', label: 'Referrals Made for Rangatahi', align: 'left', field: row => row.referrals_made_for_rangatahi }
            ],
            closureVisibleColumns: [],
            refreshing: false,
        }
    },

    computed: {
        closureTableColumns() {
            return this.closureDataColumns.map((column) => ({
                value: column.name,
                label: column.label,
            }));
        }
    },

    created() {
        this.closureVisibleColumns = this.closureDataColumns.map((column) => column.name);
    },

    methods: {

        // Refresh ASA Responses
        async refreshASAResponses() {
            this.refreshing = true;

            try {
                await api.forms.updateCaseClosureFormData()
                notify.primary('Data refreshed successfully. Please refresh page to see changes.');
            } catch (err) {
                console.log(err)
                notify.error('Failed to refresh data. Please try again later.');
            } finally {
                this.refreshing = false;
            }
        },
    }
}
</script>

<style scoped>

</style>